import React, { Component } from "react";
import { Provider } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { configurationsStore } from "../../store/store";
import "./ConfigurationsPage.component.scss";
import ConfigurationsRouter from "./ConfigurationsRouter/ConfigurationsRouter.component";

class ConfigurationsPage extends Component<RouteComponentProps, {}> {
    render() {
        return (
            <Provider store={configurationsStore}>
                <div id="ConfigurationsPage">
                    <ConfigurationsRouter />
                </div>
            </Provider>
        );
    }
}

export default withRouter(ConfigurationsPage);
